import {Component, Input} from '@angular/core';
import {LDWDocument} from "../../../shared/models/LDWDocument";

@Component({
    selector: 'ldw-document-title',
    templateUrl: './document-title.component.html',
    styleUrls: ['./document-title.component.css'],
    standalone: false
})
export class DocumentTitleComponent {

  @Input() document: LDWDocument | undefined = undefined;

  get caption():string{
    return this.document?.text??"";
  }
}
